module.exports = __webpack_public_path__ + "img/vallone-exalt-tooltips-configurator-04.7fd45f7a.jpg";